'use client'

import {
   Group,
   Paper,
   SimpleGrid,
   Stack,
   Text,
   ThemeIcon
} from '@blocks'
import {IconBolt, IconHeartHandshake, IconShieldHalf} from '@icons'

export const How = () => {
   return (
      <Stack
         id={'how'}
         my={100}
         gap={35}
      >
         <Stack
            align={'center'}
            justify={'center'}
            gap={10}
         >
            <Stack gap={5}>
               <Text
                  c={'#cb95ff'}
                  fw={500}
                  ta={'center'}
               >
                  PROCESS
               </Text>
               <Text
                  c={'white'}
                  fz={40}
                  fw={650}
                  ta={'center'}
               >
                  How We Work
               </Text>
            </Stack>
            <Text
               c={'white'}
               fz={22}
               ta={'center'}
               maw={'70%'}
            >
               You don&apos;t need to have everything figured out. Our
               collaborative process guides you from concept to
               launch.
            </Text>
         </Stack>
         <SimpleGrid
            cols={{base: 1, md: 4}}
            spacing={30}
         >
            <Stack
               align={'center'}
               justify={'flex-start'}
               gap={10}
            >
               <Group>
                  <Paper
                     py={20}
                     px={35}
                     radius={'lg'}
                     style={{
                        background:
                           'linear-gradient(153deg, #6b3593a6, #390058a6)'
                     }}
                  >
                     <Text
                        fz={30}
                        fw={650}
                     >
                        1
                     </Text>
                  </Paper>
               </Group>
               <Text
                  c={'white'}
                  fz={20}
                  fw={650}
               >
                  Discovery
               </Text>
               <Text
                  c={'white'}
                  ta={'center'}
               >
                  We start by understanding your goals, challenges,
                  and constraints. Deep conversations that uncover
                  what really matters.
               </Text>
            </Stack>
            <Stack
               align={'center'}
               justify={'flex-start'}
               gap={10}
            >
               <Group>
                  <Paper
                     py={20}
                     px={35}
                     radius={'lg'}
                     style={{
                        background:
                           'linear-gradient(153deg, #6b3593b3, #390058b3)'
                     }}
                  >
                     <Text
                        fz={30}
                        fw={650}
                     >
                        2
                     </Text>
                  </Paper>
               </Group>
               <Text
                  c={'white'}
                  fz={20}
                  fw={650}
               >
                  Strategy
               </Text>
               <Text
                  c={'white'}
                  ta={'center'}
               >
                  Translating ideas into clear technical and design
                  decisions. We map out the path from concept to
                  reality.
               </Text>
            </Stack>
            <Stack
               align={'center'}
               justify={'flex-start'}
               gap={10}
            >
               <Group>
                  <Paper
                     py={20}
                     px={35}
                     radius={'lg'}
                     style={{
                        background:
                           'linear-gradient(153deg, #6b3593d9, #390058d9)'
                     }}
                  >
                     <Text
                        fz={30}
                        fw={650}
                     >
                        3
                     </Text>
                  </Paper>
               </Group>
               <Text
                  c={'white'}
                  fz={20}
                  fw={650}
               >
                  Execution
               </Text>
               <Text
                  c={'white'}
                  ta={'center'}
               >
                  Building with precision and care. Regular updates,
                  transparent communication, and iterative refinement.
               </Text>
            </Stack>
            <Stack
               align={'center'}
               justify={'flex-start'}
               gap={10}
            >
               <Group>
                  <Paper
                     py={20}
                     px={35}
                     radius={'lg'}
                     style={{
                        background:
                           'linear-gradient(153deg, #6b3593, #390058)'
                     }}
                  >
                     <Text
                        fz={30}
                        fw={650}
                     >
                        4
                     </Text>
                  </Paper>
               </Group>
               <Text
                  c={'white'}
                  fz={20}
                  fw={650}
               >
                  Launch & Beyond
               </Text>
               <Text
                  c={'white'}
                  ta={'center'}
               >
                  Smooth deployment and ongoing support. We ensure
                  your solution continues to perform and evolve.
               </Text>
            </Stack>
         </SimpleGrid>
         <Paper
            p={40}
            mt={10}
            radius={'lg'}
            style={{
               background: '#67318f70',
               border: '1px solid #d7c7e459'
            }}
         >
            <Stack gap={30}>
               <Text
                  c={'white'}
                  fz={24}
                  fw={650}
                  ta={'center'}
               >
                  Our Approach
               </Text>
               <SimpleGrid
                  cols={{base: 1, md: 3}}
                  spacing={30}
               >
                  <Stack
                     align={'center'}
                     justify={'flex-start'}
                     gap={10}
                  >
                     <ThemeIcon
                        p={10}
                        bg={'#8b22c2'}
                        size={90}
                        color={'white'}
                        variant={'light'}
                        radius={'lg'}
                     >
                        <IconHeartHandshake
                           stroke={1.5}
                           size={50}
                        />
                     </ThemeIcon>
                     <Text
                        c={'white'}
                        fz={18}
                        fw={650}
                     >
                        Collaborative Partnership
                     </Text>
                     <Text
                        c={'white'}
                        ta={'center'}
                     >
                        We work closely with you throughout the
                        journey. Your input shapes every decision.
                     </Text>
                  </Stack>
                  <Stack
                     align={'center'}
                     justify={'flex-start'}
                     gap={10}
                  >
                     <ThemeIcon
                        p={10}
                        bg={'#8b22c2'}
                        size={90}
                        color={'white'}
                        variant={'light'}
                        radius={'lg'}
                     >
                        <IconBolt
                           stroke={1.5}
                           size={50}
                        />
                     </ThemeIcon>
                     <Text
                        c={'white'}
                        fz={18}
                        fw={650}
                     >
                        Lean & Agile
                     </Text>
                     <Text
                        c={'white'}
                        ta={'center'}
                     >
                        Fast iterations, continuous feedback, and
                        adaptive planning keep projects on track.
                     </Text>
                  </Stack>
                  <Stack
                     align={'center'}
                     justify={'flex-start'}
                     gap={10}
                  >
                     <ThemeIcon
                        p={10}
                        bg={'#8b22c2'}
                        size={90}
                        color={'white'}
                        variant={'light'}
                        radius={'lg'}
                     >
                        <IconShieldHalf
                           stroke={1.5}
                           size={50}
                        />
                     </ThemeIcon>
                     <Text
                        c={'white'}
                        fz={18}
                        fw={650}
                     >
                        Ownership & Accountability
                     </Text>
                     <Text
                        c={'white'}
                        ta={'center'}
                     >
                        We take full responsibility for delivery, so
                        you can focus on the bigger picture.
                     </Text>
                  </Stack>
               </SimpleGrid>
            </Stack>
         </Paper>
      </Stack>
   )
}
